'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002410 from "./presto.-Login-Page-View$$anon$10.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002418 from "./presto.-Login-Page-View$$anon$18.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002420 from "./presto.-Login-Page-View$$anon$20.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$00248 from "./presto.-Login-Page-View$$anon$8.js";
import * as $j_presto$002etypes$0024$002dSingle$002dApp$002dUser$0024 from "./presto.types$-Single-App-User$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$7() {
  this.b6l = null;
  this.b6d = null;
  this.b6e = false;
  this.b6m = null;
  this.b6n = false;
  this.b6q = null;
  this.b6j = null;
  this.b6k = false;
  this.b6f = null;
  this.b6g = false;
  this.b6h = null;
  this.b6i = false;
  this.b6o = false;
  this.b6p = false;
  this.b6l = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b6q = "SingleAppUser";
}
export { $c_Lpresto_LoginPageView$$anon$7 as $c_Lpresto_LoginPageView$$anon$7 };
$p = $c_Lpresto_LoginPageView$$anon$7.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$7;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$7() {
}
export { $h_Lpresto_LoginPageView$$anon$7 as $h_Lpresto_LoginPageView$$anon$7 };
$h_Lpresto_LoginPageView$$anon$7.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.b6l;
});
$p.M = (function() {
  if ((!this.b6e)) {
    this.b6d = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b6e = true;
  }
  return this.b6d;
});
$p.O = (function() {
  if ((!this.b6n)) {
    this.b6m = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b6n = true;
  }
  return this.b6m;
});
$p.E = (function() {
  return this.b6q;
});
$p.t = (function() {
  if ((!this.b6k)) {
    this.b6j = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("details", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("application", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("impersonatedBy", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.b6k = true;
  }
  return this.b6j;
});
$p.N = (function() {
  if ((!this.b6g)) {
    this.b6f = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$00248.$c_Lpresto_LoginPageView$$anon$8(), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002410.$c_Lpresto_LoginPageView$$anon$10(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder(new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002418.$c_Lpresto_LoginPageView$$anon$18())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.b6g = true;
  }
  return this.b6f;
});
$p.Q = (function() {
  if ((!this.b6i)) {
    this.b6h = new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002420.$c_Lpresto_LoginPageView$$anon$20();
    this.b6i = true;
  }
  return this.b6h;
});
$p.v = (function() {
  if ((!this.b6p)) {
    this.b6o = false;
    this.b6p = true;
  }
  return this.b6o;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee130) => ((p) => \u03b4scrutinee130.ad0(p)))($j_presto$002etypes$0024$002dSingle$002dApp$002dUser$0024.$m_Lpresto_types$SingleAppUser$())));
});
var $d_Lpresto_LoginPageView$$anon$7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$7, "presto.LoginPageView$$anon$7", ({
  Mu: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_LoginPageView$$anon$7 as $d_Lpresto_LoginPageView$$anon$7 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$7.js.map
